'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = subscriptionStore;

var _wildemitter = require('wildemitter');

var _wildemitter2 = _interopRequireDefault(_wildemitter);

var _pull = require('lodash/pull');

var _pull2 = _interopRequireDefault(_pull);

var _logger = require('../utils/logger');

var _subscription = require('../utils/subscription');

var _subscription2 = _interopRequireDefault(_subscription);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logger = (0, _logger.create)('Subscription store');

/**
 * @module SubscriptionStore
 */
var ON_WRAP_DATA_DELAY = 0;

function subscrioptionsKeeper(state) {
    var subscribed = [];
    var topicSquasher = state.topicSquasher,
        emitter = state.emitter;
    var session = state.session;

    var sourceStream = void 0;

    var isEmpty = function isEmpty() {
        return subscribed.length === 0;
    };

    function onUpdate(data, topic) {
        logger.debug('Get new data from: ' + state.topic + '\n' + data);
        var fullData = topicSquasher.getValue(topic).squash(data);
        subscribed.forEach(function (subscr) {
            subscr.onUpdate(fullData, topic);
        });
    }

    function onClose() {
        sourceStream.off('close', onClose);
        sourceStream.off('update', onUpdate);
        sourceStream = null;
    }

    function closeConnection(reason) {
        if (sourceStream) {
            sourceStream.close(reason);
        }
    }

    function getDataTopics() {
        return [state.topic];
    }

    function createFetch(subscr) {
        return function () {
            getDataTopics().map(function (topic) {
                return {
                    topic: topic,
                    data: topicSquasher.getValue(topic).getState()
                };
            }).filter(function (_ref) {
                var data = _ref.data;
                return data;
            }).forEach(function (_ref2) {
                var topic = _ref2.topic,
                    data = _ref2.data;

                subscr.onUpdate(data, topic);
            });
            emitter.emit('didFetch');
        };
    }

    function createClose(subscr) {
        return function (reason) {
            (0, _pull2.default)(subscribed, subscr);
            subscr.onClose(reason);
            emitter.emit('didClose');
        };
    }

    function openConnection() {
        if (!sourceStream && session && subscribed.length) {
            var topic = state.topic;
            sourceStream = session.stream(topic);
            sourceStream.on('close', onClose);
            sourceStream.on('update', onUpdate);
        }
    }

    return {
        closeConnection: closeConnection,
        getDataTopics: getDataTopics,
        isEmpty: isEmpty,

        /**
         * Wraps subscription and propagate last squashed data to subscriber.
         * @memberOf subscriptionStore
         * @instance
         * which should listen for subscription updates.
         */
        getSubscription: function getSubscription() {
            var newSubscription = (0, _subscription2.default)();
            subscribed.push(newSubscription);
            newSubscription.setSubscription({
                close: createClose(newSubscription),
                fetch: createFetch(newSubscription)
            });
            if (getDataTopics().some(function (topic) {
                return topicSquasher.getValue(topic).getState();
            })) {
                setTimeout(createFetch(newSubscription), ON_WRAP_DATA_DELAY);
            }
            openConnection();
            return newSubscription;
        },

        setSession: function setSession(newSession) {
            if (sourceStream) {
                onClose();
            }
            session = newSession;
            openConnection();
        }
    };
}

/**
 * Class which implements logic of merging diffusion data and handling multiple subscriptions.
 * @class subscriptionStore
 */
function subscriptionStore(topic, session, topicSquasher) {
    var emitter = new _wildemitter2.default();
    var state = {
        emitter: emitter,
        topic: topic,
        session: session,
        topicSquasher: topicSquasher
    };
    return Object.assign(emitter, subscrioptionsKeeper(state));
}


//////////////////
// WEBPACK FOOTER
// ./~/rp-diffusion-connector/lib/connector/subscriptionStore.js
// module id = 1401
// module chunks = 1